var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer pt-0",style:(_vm.$parent.styleBackground)},[_c('receita-net-copy-right')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }